import { Card } from "@/components/ui/card";
import { ShieldCheck, Zap, Users, Wrench } from "lucide-react";

export default function About() {
  return (
    <div className="mx-auto max-w-6xl px-6 lg:px-10 py-16 lg:py-20" data-testid="about-page">
      {/* Hero banner with image */}
      <div className="relative rounded-2xl overflow-hidden mb-16 aspect-[21/9] lg:aspect-[21/7]">
        <img
          src="https://customer-assets-v7afamib.emergentagent.net/job_spa-report-hub/artifacts/i4l1k62f_542DB015-7DA7-4F8F-A41A-8344510A2CB6_1_105_c.jpeg"
          alt="Spa jacuzzi extérieur"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/85 via-slate-950/50 to-slate-950/20" />
        <div className="relative h-full p-8 lg:p-12 flex flex-col justify-end text-white">
          <div className="eyebrow text-white/60">À propos</div>
          <h1 className="mt-2 font-display text-3xl lg:text-5xl font-black tracking-tighter max-w-2xl leading-[1.05]">
            Un outil pensé par des passionnés de spa.
          </h1>
        </div>
      </div>

      <div className="max-w-2xl">
        <p className="text-muted-foreground leading-relaxed">
          DoctoSpa est né d'un constat simple : la plupart des pannes de spa domestique ne
          nécessitent pas une intervention technique de 150€. Un débit faible ? Un filtre
          encrassé. Une odeur inhabituelle ? Un pH mal réglé. Un panneau qui bloque ? Souvent,
          un simple redémarrage.
        </p>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Nous avons compilé les pannes les plus courantes rencontrées sur les spas résidentiels
          — Aquavia, Caldera, Jacuzzi, Sundance, Wellis, et bien d'autres — pour créer un moteur
          d'analyse capable d'identifier ce qui cloche en 2 minutes chrono.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {[
          { icon: Zap, title: "Rapide", desc: "18 questions ciblées, 2 minutes chrono. Pas de blabla, pas de vente forcée." },
          { icon: Wrench, title: "Actionnable", desc: "Nos rapports décrivent le geste concret à effectuer, pas des généralités." },
          { icon: Users, title: "Domestique", desc: "Conçu pour les propriétaires de spas résidentiels, pas pour les experts." },
          { icon: ShieldCheck, title: "Fiable", desc: "Règles issues des retours SAV et des manuels constructeurs les plus courants." },
        ].map((v) => (
          <Card key={v.title} className="p-6 border-black/10">
            <span className="h-10 w-10 rounded-lg bg-primary/10 text-primary grid place-items-center">
              <v.icon className="h-5 w-5" />
            </span>
            <h3 className="mt-5 font-display text-lg font-semibold">{v.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
          </Card>
        ))}
      </div>

      <div className="mt-20 border-t border-black/5 pt-10">
        <div className="eyebrow">Notre mission</div>
        <h2 className="mt-3 font-display text-3xl font-bold tracking-tight max-w-2xl">
          Rendre l'entretien technique de votre spa accessible, sans jargon et sans surcoût.
        </h2>
      </div>
    </div>
  );
}
